module.exports = __webpack_public_path__ + "media/images/media-elements/replay-11d3b1a92bff9d8a0cd5c1c6ead433b0.svg";